var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOfferError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 396 259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #f2f2f2;\n      }\n\n      .cls-1, .cls-3 {\n        isolation: isolate;\n        opacity: .5;\n      }\n\n      .cls-4 {\n        fill: #f4897d;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #f8563f;\n      }\n\n      .cls-7, .cls-3 {\n        fill: #f7f7f7;\n      }\n\n      .cls-8 {\n        fill: none;\n        stroke: #f4897d;\n        stroke-dasharray: 12 12;\n        stroke-linecap: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M390.9,195.7c8.2-35.4,9.7-101.1-50.3-80.7-74.9,25.6-82.8,208.5-139.9,120C143.6,146.5-53.5,164.2,15.5,95.3,84.4,26.5,221.4-38.4,166.2,46.2c-55.2,84.6-9.9,208.5-73.9,198.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.3,137.6c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5,3.5,1.6,3.5,3.5-1.6,3.5-3.5,3.5ZM328.3,132.1c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2ZM95.8,66c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5,3.5,1.6,3.5,3.5-1.6,3.5-3.5,3.5ZM95.8,60.5c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.4,214.4h-1.8v-2.6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2.6h-1.8c-.3,0-.5.2-.5.5s.2.5.5.5h1.8v2.6c0,.3.2.5.5.5s.5-.2.5-.5v-2.6h1.8c.3,0,.5-.2.5-.5s-.2-.5-.5-.5ZM305.6,4.6h-2.7V.8c0-.4-.3-.8-.8-.8s-.8.3-.8.8v3.9h-2.7c-.4,0-.8.3-.8.8s.3.8.8.8h2.7v3.9c0,.4.3.8.8.8s.8-.3.8-.8v-3.9h2.7c.4,0,.8-.3.8-.8s-.3-.8-.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299.4,45.7l-.4-8.5c0-.6.5-1.2,1.1-1.2.6,0,1.2.5,1.2,1.1l.4,8.5c0,.6-.5,1.2-1.1,1.2-.6,0-1.2-.5-1.2-1.1ZM310.7,55.9c0-.6.5-1.2,1.1-1.2l8.5-.4c.6,0,1.2.5,1.2,1.1,0,.6-.5,1.2-1.1,1.2l-8.5.4c-.6,0-1.2-.5-1.2-1.1ZM307.3,48.3c0-.3,0-.6.3-.8l5.5-6.1c.4-.5,1.2-.5,1.6,0,.5.4.5,1.2,0,1.6l-5.5,6.1c-.4.5-1.2.5-1.6,0-.2-.2-.4-.5-.4-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.8,76.4l-13.8-3.7,3.1-11.5c.7-2.5-.8-5.1-3.3-5.7l-114.9-30.8c-2.5-.7-5,.8-5.7,3.3l-43.3,161.5c-.7,2.5.8,5,3.3,5.7l114.9,30.8c2.5.7,5-.8,5.7-3.3l22.5-83.8,13.8,3.7c3.3.9,6.7-1.1,7.6-4.4l14.5-54.2c.9-3.3-1.1-6.7-4.4-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.7,203.1l-112.3,5.6c-2.6.1-4.7-1.8-4.9-4.4l-7.9-158c-.1-2.6,1.8-4.7,4.4-4.9l19.7-1,92.5-4.7c2.6-.1,4.7,1.8,4.9,4.4l7.9,157.3v.6c.2,2.6-1.8,4.7-4.4,4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.1,197.6l-61-4.1-49.6-3.3c-2.6-.2-4.5-2.4-4.3-4.9l9.6-144.8,92.5-4.7c2.6-.1,4.7,1.8,4.9,4.4l7.9,157.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M263.5,40l-.4,5.4-10.1,152.4c-.2,2.6-2.4,4.5-4.9,4.3l-62.6-4.2-49.6-3.3c-2.6-.2-4.5-2.4-4.3-4.9l10.5-157.8c.2-2.6,2.4-4.5,4.9-4.3l26.5,1.8,39.4,2.6,46.2,3.1c2.6.2,4.5,2.4,4.3,4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.1,45.4l-10.1,152.4c-.2,2.6-2.4,4.5-4.9,4.3l-62.6-4.2-49.2-13.2c-2.3-.6-3.6-2.9-3-5.2L173.5,29.4l39.4,2.6,50.2,13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M248.8,220.1l-109.3-29.3c-2.3-.6-3.6-2.9-3-5.2l41-153.1c.7-2.5,3.2-3.9,5.7-3.3l108.9,29.2c2.3.6,3.6,2.9,3,5.2l-41.1,153.5c-.6,2.3-2.9,3.6-5.2,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.2,153.7c15.7,4.3,31.9-5,36.2-20.7,4.3-15.7-5-31.9-20.7-36.2-15.7-4.3-31.9,5-36.2,20.7s5,31.9,20.7,36.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.8,162.5c-20.5-5.6-32.7-26.8-27.1-47.4,5.6-20.5,26.8-32.7,47.4-27.1,20.5,5.6,32.7,26.8,27.1,47.4-5.6,20.5-26.8,32.7-47.4,27.1ZM223.9,92.3c-18.2-5-37,5.8-42,24-5,18.2,5.8,37,24,42,18.2,5,37-5.8,42-24,5-18.2-5.8-37-24-42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M226.6,112.4l4.5,6.2-27.1,19.6-4.7-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.3,113.9l6.2-4.5,19.6,27.1-6.5,4.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOfferError);
export default __webpack_public_path__ + "static/media/add_offer_error.449055e675845bdf9cda1132b9276779.svg";
export { ForwardRef as ReactComponent };